<script setup>
import Dialog from "primevue/dialog";
import {Deferred, usePage} from "@inertiajs/vue3";
import {breakpointsTailwind, useBreakpoints} from "@vueuse/core";
import SettingsModel from "./SettingsModel.vue";
import {ref} from "vue";

const visible = defineModel('visible');

const breakpoints = useBreakpoints(breakpointsTailwind);

const dialog = ref();

const onShowDialog = () => {
    dialog.value.maximized = true
}

</script>

<template>
    <Dialog modal ref="dialog" @show="onShowDialog" :maximizable="breakpoints.isSmallerOrEqual('md')" :transitionOptions="null" v-model:visible="visible" class="md:h-[500px] w-[800px] max-md:!rounded-none">
        <template #container>
            <Deferred data="settings">
                <settings-model v-model="visible"></settings-model>
                <template #fallback></template>
            </Deferred>
        </template>
    </Dialog>
</template>

<style scoped lang="scss">

</style>
